import { render, staticRenderFns } from "./RecurrenceCalendar.vue?vue&type=template&id=96c545b2&scoped=true"
import script from "./RecurrenceCalendar.vue?vue&type=script&lang=js"
export * from "./RecurrenceCalendar.vue?vue&type=script&lang=js"
import style0 from "./RecurrenceCalendar.vue?vue&type=style&index=0&id=96c545b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c545b2",
  null
  
)

export default component.exports